<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <el-form label-position="top">
                    <el-form-item label="筛选是否同有课学生">
                        <el-select v-model="filter.hasClass" placeholder="请选择学期" clearable @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in specialTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                        <el-form-item label="选择日期">
                            <div class="block">
                                <el-date-picker
                                        v-model="date"
                                        type="daterange"
                                        align="right"
                                        unlink-panels
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        value-format="yyyy-MM-dd"
                                        :clearable="true"
                                        :picker-options="pickerOptions2"
                                        @change="changeDate(date)">
                                </el-date-picker>
                            </div>
                        </el-form-item>

                    <el-form-item label="筛选班主任">
                        <el-select v-model="filter.headTeacher_id" clearable placeholder="请选择班主任" filterable remote
                                   :remote-method="handleSearchHeadTeacher" @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in search.headTeachers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="筛选是否有班主任的学生" >
                        <el-select v-model="filter.hasHeadTeacher" clearable placeholder="是否有班主任的学生"
                                   @change="handleIndexStudent()">
                            <el-option
                                    v-for="item in hasHeadTeacherStudents"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                </el-form>
            </div>
        </div>
        <div class="m-portlet right m-b-0">
            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59+'px'}" v-loading="loading">
                <el-table v-if="!loading"
                          :data="orderStudents"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-20"
                          size="middle">
                    <el-table-column prop="id" label="学号" min-width="5%"></el-table-column>
                    <el-table-column prop="name" label="姓名" min-width="10%"> </el-table-column>
                    <el-table-column label="学校" min-width="10%">
                        <template slot-scope="scope">
                            <span v-if="scope.row.current_education.length!=0">{{scope.row.current_education.school.name}}</span>
                            <span v-else>学校未添加</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="年级" min-width="5%">
                        <template slot-scope="scope">
                            <span v-if="scope.row.current_education.length!=0">{{scope.row.current_education.grade.name}}</span>
                            <span v-else>年级未添加</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="班主任" min-width="10%">
                        <template slot-scope="scope">
                            <span v-for="(headTeacher,index) in scope.row.headTeachers" :key="index"> {{headTeacher.name}} </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="完善信息" min-width="10%">
                        <template slot-scope="scope">
                            <div v-if="scope.row.headTeachers.length==0">
                                <el-button size="mini" @click="handleChangeInformation(scope.row.id)">完善信息</el-button>
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column label="注册时间" prop="created_at" min-width="10%"></el-table-column>
                </el-table>
            </div>

            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                path: '/student/management/list',
                loading: true,
                isHeadTeacher:false,
                students: [],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                semesters: [],
                headTeachers: [],
                schools: [],
                grades: [],
                date: '',
                hasHeadTeacherStudents: [
                    {
                        value: '1',
                        label: '有班主任的学生'
                    }, {
                        value: '0',
                        label: '没有班主任的学生'
                    }],
                specialTypes:[
                    {
                        value: '1',
                        label: '有课'
                    },
                    {
                        value: '0',
                        label: '没课'
                    },

                ],

                filter:{
                    hasHeadTeacher: '',
                    headTeacher_id: '',
                    hasClass:'',
                    start_date:'',
                    end_date:''
                },
                pickerOptions2: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                dialog_ChangeInformation: {
                    button_loading: false,
                    loading: true,
                    title: '更改学生信息',
                    filter: {
                        schools: [],
                        grades: [],
                        hobbies: [],
                        star_level: [],
                        schoolClasses: [],
                        parent_identity: ['父亲', '母亲', '其他'],
                        headTeachers: [],
                    },
                    student: {
                        id: '',
                        birthday: '',
                        current_education: {
                            grade: {
                                id: '',
                                name: '',
                            },
                            school: {
                                id: '',
                                name: '',
                            },
                            schoolClass: {
                                id: '',
                                name: '',
                            },
                        },
                        gender_id: '',
                        headTeachers: [],
                        name: '',
                        parents: [],
                        phone: '',
                        qq: '',
                        referrer_name: '',
                        referrer_type: '',
                        star: 0,
                        subjects: [],
                        wechat:'',
                        promotion_channel_ids: [],
                        other_channel_remark: '',
                        conversion:false
                    },
                },
                search:{
                    grades: {
                        id: '',
                        name: '',
                        status: '',
                        color: '',
                    },
                    headTeachers: {
                        id: '',
                        name: '',
                    },
                    organizationServices: {
                        id: '',
                        name: '',
                        nowSemester_id: '',
                    },
                    parent_identity: [],
                    schoolClasses: {
                        id: '',
                        name: '',
                    },
                    schools: {
                        id: '',
                        name: '',
                        school_type: '',
                        school_level: '',
                        address: '',
                        province_code: '',
                    },
                    star_level: {
                        id: '',
                        name: '',
                        number: '',
                    },
                    subjects: {
                        id: '',
                        name: '',
                        mainJudge: '',
                        color: '',
                    },
                    promotion_channels: {
                        id: '',
                        name: ''
                    },
                    students:[]
                }
            }
        },
        props: {},
        components: {},
        created() {
            this.handleCreate();
            this.handleIndexStudent();
            this.handleSearchHeadTeacher('');
        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path)
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            orderStudents: function () {
                return this._.values(this.students);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'list':
                        if (Object.keys(data.students).length > 0) {
                            this.students = data.students;
                        } else {
                            this.students = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'show_student':
                        this.dialog_ChangeInformation.student = JSON.parse(JSON.stringify(data.student));
                        this.dialog_ChangeInformation.student.headTeachers = [];
                        this.dialog_ChangeInformation.student.subjects = [];
                        JSON.parse(JSON.stringify(data.student.headTeachers)).forEach((item) => {
                            this.dialog_ChangeInformation.student.headTeachers.push(item.id)
                        });
                        JSON.parse(JSON.stringify(data.student.subjects)).forEach((item) => {
                            this.dialog_ChangeInformation.student.subjects.push(item.id);
                        });
                        this.isHeadTeacher = data.isHeadTeacher;
                        break;
                    case 'get_init':
                        this.search = data;
                        this.search.students=[];
                        break;
                    case 'searchHeadTeacher':
                        this.search.headTeachers = data.searchData.searchData;
                        break;
                    case 'searchStudent':
                        this.search.students = data.searchData.students;
                        break;
                    case 'searchSchool':
                        this.search.schools=data.searchData.searchData;
                        break;
                    case 'updateStudentInformation':
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.dialog_ChangeInformation.button_loading = false;
                        this.$set(this.students,data.student.id,data.student)
                        this.$Win.closeModal();
                        break;
                }
            },
            changeDate() {
                if (this.date == null) {
                    this.date = ["1000-01-01", "9999-01-01"]
                }
                this.filter.start_date = this.date[0];
                this.filter.end_date = this.date[1];
                this.loading = true;
                this.handleIndexStudent();
            },
            handleIndexStudent(currentPage=1) {
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'filter': this.filter,
                });
            },
            handleSearchHeadTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'type':'searchHeadTeacher',
                    'headTeacherKeyName': query,
                })
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexStudent(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexStudent(this.currentPage)
            },
            handleChangeInformation(student_id) {
                this.$Win.openModal('Dialog_UpdateStudent', 800, 800, '修改学生',{'student_id':student_id});
            },
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 420px;
    }

    .right {
        margin-left: 425px;
    }
</style>
